/* eslint-disable @typescript-eslint/no-unused-vars */
import SideSelect from './SideSelect';

import { INTEGRATION_SIDE_CONFIG } from '@/static/content/pl/integration/integration-side-content';

export default function SideSelectWrapper() {
    const rawListData = INTEGRATION_SIDE_CONFIG.listData;

    const cleanedListData = rawListData.map(({ title, ...rest }) => ({
        ...rest,
        list: rest.list.map(({ Icon, ...itemRest }) => ({ ...itemRest })),
    }));

    return <SideSelect listData={cleanedListData} />;
}
